import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="not-found-page">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-4 py-32 text-center">
        <div className="font-display text-7xl font-bold text-[#0B192C]">404</div>
        <p className="text-[#4B5563] mt-4">We couldn't find that page.</p>
        <Link
          to="/"
          className="mt-6 inline-flex rounded-md bg-[#D32F2F] hover:bg-[#B71C1C] text-white font-semibold px-6 py-3"
        >
          Back home
        </Link>
      </main>
      <Footer />
    </div>
  );
}
